/**
 * TanStack Query hooks para /v1/audit-log — FWA-PWA-033.
 */
import { useQuery } from '@tanstack/react-query';
import { type ApiResponse, apiGet } from '../api.js';

export interface AuditLogEntry {
  event_id: string;
  event_type: string;
  occurred_at: string;
  distrito_id: string;
  actor_email: string;
  request_id: string;
  entity_id: string | null;
  entity_type: string | null;
  access_reason: string | null;
  summary: string;
}

export interface AuditLogFilters {
  event_type?: string | undefined;
  actor_email?: string | undefined;
  from?: string | undefined;
  to?: string | undefined;
  cursor?: string | undefined;
  limit?: number | undefined;
}

interface AuditLogListResponse {
  data: AuditLogEntry[];
  next_cursor: string | null;
  has_more: boolean;
}

export const auditKeys = {
  all: ['audit-log'] as const,
  list: (filters: AuditLogFilters) => ['audit-log', 'list', filters] as const,
};

function buildQueryString(filters: AuditLogFilters): string {
  const params = new URLSearchParams();
  if (filters.event_type) params.set('event_type', filters.event_type);
  if (filters.actor_email) params.set('actor_email', filters.actor_email);
  if (filters.from) params.set('from', filters.from);
  if (filters.to) params.set('to', filters.to);
  if (filters.cursor) params.set('cursor', filters.cursor);
  if (filters.limit) params.set('limit', String(filters.limit));
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export function useAuditLogList(filters: AuditLogFilters = {}) {
  return useQuery<ApiResponse<AuditLogListResponse>>({
    queryKey: auditKeys.list(filters),
    queryFn: () => apiGet<AuditLogListResponse>(`/v1/audit-log${buildQueryString(filters)}`),
  });
}
